/// <reference path="../../../../typings/index.d.ts" />
angular.module('app').factory('ReportAccessServiceApi', ($http, ApiErrorService) => {
    return {
        getReportAccessGridAsListStrings: getReportAccessGridAsListStrings,
        getSimulatorsForReport: getSimulatorsForReport,
        addSimulatorToReport: addSimulatorToReport,
        removeSimulatorFromReport: removeSimulatorFromReport,
        saveReportAccessList: saveReportAccessList,
        saveReportAccessGrid: saveReportAccessGrid
    };
    function getReportAccessGridAsListStrings() {
        return $http.get(`api/ReportAccess/GetReportAccessGridAsListStrings`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getSimulatorsForReport(reportId) {
        return $http.get(`api/ReportAccess/GetSimulatorsForReport?reportId=${reportId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function addSimulatorToReport(reportId, simulatorId) {
        return $http.post(`api/ReportAccess/AddSimulatorToReport?reportId=${reportId}&simulatorId=${simulatorId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function removeSimulatorFromReport(reportId, simulatorId) {
        return $http.post(`api/ReportAccess/RemoveSimulatorFromReport?reportId=${reportId}&simulatorId=${simulatorId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function saveReportAccessList(repAccessEx) {
        return $http.post(`api/ReportAccess/saveReportAccessList`, repAccessEx)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function saveReportAccessGrid(repAccessEx) {
        return $http.post(`api/ReportAccess/SaveReportAccessGrid`, repAccessEx)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
});
